"use client";

import { GlobalOperationsDesktop } from "./global-operation-desktop";
import { GlobalOperationsMobile } from "./global-operation-mobile";
import WorldPresenceMap from "./WorldPresenceMap";

export function GlobalOperations() {
  return (
    <section className="w-full bg-(--mmi-black)">
      <section id="global-presence" className="py-16" style={{ background: "oklch(0.13 0.01 85)" }}>
  <div className="mx-auto max-w-[1500px] px-[3%] lg:px-[5%]">
    <WorldPresenceMap />
  </div>
</section>
    </section>
  );
}
